export const VERSION = process.env.REACT_APP_VERSION;
export const API_URL = process.env.REACT_APP_API_URL;
export const CLIENT_URL = process.env.REACT_APP_CLIENT_URL;
export const SHOPIFY_CLIENT_ID = process.env.REACT_APP_SHOPIFY_CLIENT_ID;
export const SHOPIFY_PRICE_FREE = false;
